import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

export type MetricsViewMode = 'hiring_goal' | 'date_range';

interface MetricsViewToggleProps {
  value: MetricsViewMode;
  onChange: (value: MetricsViewMode) => void;
}

export function MetricsViewToggle({ value, onChange }: MetricsViewToggleProps) {
  return (
    <div
      className="border-fx-neutral-200 flex w-full gap-2 rounded-[10px] border bg-white p-[5px]"
      role="tablist"
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === 'hiring_goal'}
        onClick={() => onChange('hiring_goal')}
        className={clsx(
          'text-body flex-1 rounded-lg px-4 py-1 leading-5 font-medium transition-colors',
          value === 'hiring_goal'
            ? 'bg-fx-brand-50 text-fx-brand-600'
            : 'text-fx-neutral-600 hover:bg-fx-brand-50',
        )}
      >
        <FormattedMessage
          defaultMessage="Hiring goal"
          description="Segmented control: show hiring goal dates and target"
        />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'date_range'}
        onClick={() => onChange('date_range')}
        className={clsx(
          'text-body flex-1 rounded-lg px-4 py-1 leading-5 font-medium transition-colors',
          value === 'date_range'
            ? 'bg-fx-brand-50 text-fx-brand-600'
            : 'text-fx-neutral-600 hover:bg-fx-brand-50',
        )}
      >
        <FormattedMessage
          defaultMessage="Date range"
          description="Segmented control: filter opening metrics by date range"
        />
      </button>
    </div>
  );
}
